import lang from "../i18n";

export const ROLE_ID_SUPERADMIN = 1;
export const ROLE_ID_ADMIN = 2;
export const ROLE_ID_KEPALA_DINAS = 3;
export const ROLE_ID_KEPALA_SEKOLAH = 4;
export const ROLE_ID_GURU = 5;
export const ROLE_ID_API = 6;

export const SORT_ASCENDING = "ASC";
export const SORT_DESCENDING = "DESC";
export const SORT_DEFAULT = "";

export const DEFAULT_PAGING = 10;
export const INIT_PAGE_STATE = {
  currentPage: 1,
  pageSizes: [10, 15, 20],
  selectedPageSize: 10,
  totalItem: 0,
  itemCount: 0,
  totalPage: 1,
};

export const POLLING = {
  municipal: 3000, //3 second
  import: 3000,
};

export const IMPORT_LOG_STATUS = {
  'SUCCESS' : {
    statusKey: "importLog.status.SUCCESS",
    color: "bg-green-100 text-green-800",
  },
  'FAILED': {
    statusKey: "importLog.status.FAILED",
    color: "bg-red-100 text-red-800",
  },
  'ERROR': {
    statusKey: "importLog.status.ERROR",
    color: "bg-red-100 text-red-800",
  },
  'WARN': {
    statusKey: "importLog.status.WARN",
    color: "bg-yellow-100 text-yellow-800",
  },
  'INFO': {
    statusKey: "importLog.status.INFO",
    color: "bg-blue-100 text-blue-800",
  },
  'PROGRESS': {
    statusKey: "importLog.status.PROGRESS",
    color: "bg-blue-100 text-blue-800",
  },
};

export const ROLE = {
  1: {
    value: ROLE_ID_SUPERADMIN,
    name: "管理者",
    previledge: [
      "admin",
      "import-log",
      "import-log/progress",
      "sync-log",
      "giga-school-api-log",
      "recovery-log",
      "oauth-key-management",
      "setting",
      "blob-setting",
      "entra-sync",
      "entra-view",
      "gws-sync",
      "roster-import",
    ],
    forbiddenAction: [],
    defaultRedirect: "import-log"
  },
};

export const ROLE_USER = {
  teacher: "先生",
  student: "生徒",
  guardian: "保護者",
  administrator: "学校管理者",
};

export const NOTIFY = (toast) => {
  return toast.success(lang.t("draft.savedSuccess"), {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
  });
};

export const SCHOOL_TYPE_LIST = [
  {
    key: "P",
    name: "小学校",
  },
  {
    key: "J",
    name: "中学校",
  },
  {
    key: "PJ",
    name: "義務教育学校",
  },
  {
    key: "JH",
    name: "中等教育学校",
  },
  {
    key: "H",
    name: "高等学校（学年制）",
  },
  {
    key: "U",
    name: "高等学校（単位制）",
  },
  {
    key: "S",
    name: "特別支援学校",
  },
  {
    key: "A",
    name: "その他",
  },
];

export const MUNICIPAL_SYNC_NAME = [
  {
    name: "academic_sessions",
    lable: lang.t("sync.label.year"),
    total_row: 0,
    progress_row: 0,
  },
  {
    name: "SYNC_SCHOOLS",
    lable: lang.t("sync.label.school"),
    total_row: 0,
    progress_row: 0,
  },
  {
    name: "SYNC_CLASSES",
    lable: lang.t("sync.label.class"),
    total_row: 0,
    progress_row: 0,
  },
  {
    name: "courses",
    lable: lang.t("sync.label.course"),
    total_row: 0,
    progress_row: 0,
  },
  {
    name: "SYNC_USERS",
    lable: lang.t("sync.label.user"),
    total_row: 0,
    progress_row: 0,
  },
  {
    name: "SYNC_ENROLLMENTS",
    lable: lang.t("sync.label.enrollment"),
    total_row: 0,
    progress_row: 0,
  },
  {
    name: "SYNC_ROLES",
    lable: lang.t("sync.label.roles"),
    total_row: 0,
    progress_row: 0,
  },
];